var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaximizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 15",
    style: {
      enableBackground: "new 0 0 15 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t    .maximize-icon-st0{fill:currentColor;}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "maximize-icon-st0",
    d: "m 5.1780862,1.4277034 c -0.6874993,0 -1.2503827,0.5628834 -1.2503827,1.2503827 V 4.1654794 H 5.1780862 V 2.6780861 h 1.485874 V 1.4277034 Z m 6.0088258,0 v 1.2503827 h 1.490432 v 1.4873933 h 1.250383 V 2.6780861 c 0,-0.6874993 -0.562884,-1.2503827 -1.250383,-1.2503827 z M 3.9277035,8.6899506 v 1.4873934 c 0,0.687499 0.5628834,1.250383 1.2503827,1.250383 H 6.6654795 V 10.177344 H 5.1780862 V 8.6899506 Z m 8.7496405,0 v 1.4873934 h -1.487393 v 1.250383 h 1.487393 c 0.687499,0 1.250383,-0.562884 1.250383,-1.250383 V 8.6899506 Z",
    transform: "matrix(1.2855439,0,0,1.2855439,-3.9769696,-0.76310981)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximizeIcon);
export default __webpack_public_path__ + "static/media/maximize-icon.bbde1d609eb7c07902317c96aa52575f.svg";
export { ForwardRef as ReactComponent };